/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowDownRight = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m7 7 10 10" }],
    ["path", { d: "M17 7v10H7" }]
  ]
];

export { ArrowDownRight as default };
//# sourceMappingURL=arrow-down-right.js.map
